const comparisonRows = [
  { feature: 'Facilit\u00e0 utilizzo', itaobuy: '\u2B50\u2B50\u2B50\u2B50\u2B50', tradizionale: '\u2B50\u2B50\u2B50' },
  { feature: 'Automazione', itaobuy: 'Alta', tradizionale: 'Bassa' },
  { feature: 'Gestione dati', itaobuy: 'Avanzata', tradizionale: 'Limitata' },
  { feature: 'Risparmio tempo', itaobuy: 'Elevato', tradizionale: 'Medio' },
  { feature: 'Personalizzazione', itaobuy: 'Completa', tradizionale: 'Parziale' },
  { feature: 'Supporto', itaobuy: 'Dedicato', tradizionale: 'Standard' },
];

export default function ComparisonSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            <strong>Itaobuy Spreadsheet</strong> a confronto
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Scopri le differenze tra Itaobuy Spreadsheet e i metodi tradizionali di gestione dati.
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200 bg-primary-50/50">
                  <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-900">Caratteristica</th>
                  <th className="text-center px-6 py-4 text-sm font-semibold text-primary-700">
                    <strong>Itaobuy Spreadsheet</strong>
                  </th>
                  <th className="text-center px-6 py-4 text-sm font-semibold text-foreground-700">Metodo tradizionale</th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row, idx) => (
                  <tr key={row.feature} className={`border-b border-background-200 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                    <td className="px-6 py-4 text-sm text-foreground-800 font-medium">{row.feature}</td>
                    <td className="px-6 py-4 text-sm text-primary-700 font-semibold text-center">{row.itaobuy}</td>
                    <td className="px-6 py-4 text-sm text-foreground-500 text-center">{row.tradizionale}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}